module.exports = __webpack_public_path__ + "static/media/icon-person.9719db9b.svg";